module.exports = __webpack_public_path__ + "img/red-desert-3.6c3aa5ba.png";